import React, { memo } from "react";

/**
 * A component that displays a preview of the first 5 rows of data to be imported.
 * @param {array} data - The data to be previewed.
 * @param to
 * @returns {jsx} A table with the preview data.
 */
const PreviewData = ({ data, to, className }) => {
  return (
    <React.Fragment>
      {data.length > 0 && (
        <div
          className={` ${className ? className : "mb-8 mt-5"} ${
            to
              ? "mb-3 mt-2 rounded border dark:border-gray-600"
              : "-mx-2 md:-mx-4"
          }`}
        >
          {!to && (
            <h3 className="mb-5 px-5 text-lg text-gray-700 dark:text-gray-400">
              {/* Display a heading with the text "Preview (first 2 rows)" */}
              العرض (اول صفين)
            </h3>
          )}
          <div className="relative overflow-x-auto">
            <table className="w-full text-left text-sm text-gray-500 dark:text-gray-400 rtl:text-right">
              <thead className="bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  {/* Map over the first row of data (headers) and create a table header for each one */}
                  {data[0].map((header, index) => (
                    <th
                      key={index}
                      scope="col"
                      className="whitespace-nowrap px-6 py-2.5"
                    >
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {/* Map over the remaining rows of data and create a table row for each one */}
                {data.slice(1).map((row, rowIndex) => (
                  <tr
                    key={rowIndex}
                    className="border-b bg-white dark:border-gray-500 dark:bg-gray-600 dark:text-gray-400"
                  >
                    {/* Map over each cell in the row and create a table data element for each one */}
                    {row.map((cell, cellIndex) => (
                      <td
                        key={cellIndex}
                        className="whitespace-nowrap px-6 py-2"
                      >
                        {/* If the cell value is longer than 30 characters, truncate it and add an ellipsis */}
                        {cell?.length > 30
                          ? cell?.substring(0, 30) + "..."
                          : cell}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default memo(PreviewData);
